import { ADDITIONALFIELDS, APIBASE_URL } from "../config/cacheKey";
import { IAdditionalFieldsRsponse, SetAdditionalFieldsRequest, SetAdditionalFieldsResponse } from "../models/additionalFeilds.model";
import { ApiResultModel } from "../models/common.model";
import { IRefrenceKeyRequest } from "../models/registration.model";
import Axios from 'axios';
export const GetAdditionalFields = (data: IRefrenceKeyRequest): Promise<IAdditionalFieldsRsponse> => {
    return Axios.post<ApiResultModel<IAdditionalFieldsRsponse>>(
        APIBASE_URL + ADDITIONALFIELDS + '/GetAdditionalFields',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const SetAdditionalFields = (data: SetAdditionalFieldsRequest): Promise<ApiResultModel<SetAdditionalFieldsResponse[]>> => {
    return Axios.post<ApiResultModel<SetAdditionalFieldsResponse[]>>(
        APIBASE_URL + ADDITIONALFIELDS + '/SetAdditionalFields',
        data
    ).then((result) => {
        return result.data;
    });
};